import { Link, useSearchParams } from 'react-router';
import { LoginForm } from '@/components/auth/LoginForm';

export function LoginPage() {
  const googleClientId = import.meta.env.VITE_GOOGLE_CLIENT_ID ?? null;
  const [params] = useSearchParams();
  // Only allow whitelisted in-app `next` targets so a crafted URL can't
  // redirect off-site after login. Accept-invite is the only deep link the
  // groups feature needs today; grow this list as more are added.
  const rawNext = params.get('next');
  const next =
    rawNext &&
    (rawNext.startsWith('/accept_group_invite/') ||
      rawNext.startsWith('/join/') ||
      rawNext.startsWith('/upgrade'))
      ? rawNext
      : null;
  const inviteToken = params.get('inviteToken');

  return (
    <main className="mx-auto flex min-h-dvh max-w-md flex-col px-6 py-8">
      <Link to="/" className="mb-10 flex items-center gap-2 text-sm text-[color:var(--color-fg-muted)]">
        <span aria-hidden>←</span> Back
      </Link>
      <div className="flex flex-1 flex-col justify-center gap-8">
        <header className="flex flex-col gap-1">
          <h1 className="text-2xl font-semibold">Log in</h1>
          <p className="text-sm text-[color:var(--color-fg-muted)]">
            Welcome back. Predict, compete, gloat responsibly.
          </p>
        </header>

        <LoginForm
          googleClientId={googleClientId || null}
          next={next}
          inviteToken={inviteToken}
        />

        <p className="text-center text-sm text-[color:var(--color-fg-muted)]">
          No account yet?{' '}
          <Link
            to={
              next
                ? `/signup?${new URLSearchParams({ next }).toString()}`
                : '/signup'
            }
            className="text-[color:var(--color-fg)] underline underline-offset-2"
          >
            Create one
          </Link>
        </p>
      </div>
    </main>
  );
}
